import React from "react";
import {Switch, Redirect} from "react-router-dom";

import Collection from "./components/Services";
import Object from "./components/Service";

import ErrorBoundaryRoute from "../../../../containers/ErrorBoundaryRoute";

export default ({match, locations}) => (
	<div>
		<Switch>
			<ErrorBoundaryRoute exact path={`${match.url}`}>
				<Collection locations={locations} />
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute path={`${match.url}/:id`}>
				<Object locations={locations} baseUrl={`${match.url}`} />
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute>
				<Redirect to={`${match.url}`} />
			</ErrorBoundaryRoute>
		</Switch>
	</div>
);
